import {Component, EventEmitter, Input, Output, ChangeDetectionStrategy} from '@angular/core';
import {BicToggleComponent} from '@buildinginformationcloud/bic-ui-components';
import {JsonSchema} from '../schema-form.types';

/** boolean → toggle (bic-toggle). */
@Component({
  selector: 'sf-toggle',
  standalone: true,
  imports: [BicToggleComponent],
  changeDetection: ChangeDetectionStrategy.Eager,
  template: `
    <bic-toggle [value]="!!value" (valueChanged)="valueChange.emit($event)"></bic-toggle>
  `,
})
export class SfToggleComponent {
  @Input() schema: JsonSchema | null = null;
  @Input() value: any;
  @Output() valueChange = new EventEmitter<any>();
}
